import { createStyles } from '@mantine/core';
import { FindFactionColor } from '../../factionalwarfare/FactionColors.js';
var useStyles = createStyles(function () {
  var amarr = FindFactionColor("amarr");
  var caldari = FindFactionColor("caldari");
  var gallente = FindFactionColor("gallente");
  var minmatar = FindFactionColor("minmatar");
  var angel = FindFactionColor("angel");
  var guristas = FindFactionColor("guristas");
  return {
    root: {
      display: "grid",
      minHeight: 100,
      gridTemplateColumns: "80px auto",
      gridTemplateRows: "100px",
      backgroundColor: "#171A1B",
      color: "#fff",
      "@media (min-width: 400px)": {
        minHeight: 100,
        gridTemplateColumns: "100px auto",
        gridTemplateRows: "100px"
      },
      "@media (min-width: 1300px)": {
        minHeight: 150,
        gridTemplateColumns: "150px auto",
        gridTemplateRows: "150px"
      }
    },
    amarr: {
      "--factionMainColor": amarr,
      "--factionAltColor": "#16191A"
    },
    caldari: {
      "--factionMainColor": caldari,
      "--factionAltColor": "#16191A"
    },
    gallente: {
      "--factionMainColor": gallente,
      "--factionAltColor": "#16191A"
    },
    minmatar: {
      "--factionMainColor": minmatar,
      "--factionAltColor": "#16191A"
    },
    angel: {
      "--factionMainColor": angel,
      "--factionAltColor": "#16191A"
    },
    guristas: {
      "--factionMainColor": guristas,
      "--factionAltColor": "#16191A"
    },
    noFaction: {
      "--factionMainColor": "white",
      "--factionAltColor": "#16191A"
    },
    portrait: {
      position: "relative",
      display: "table-cell",
      verticalAlign: "bottom"
    },
    rank: {
      position: "absolute",
      top: 0,
      left: "0px",
      padding: "2px 7px",
      fontSize: "20px",
      "@media (min-width: 1300px)": {
        left: "20px",
        padding: "5px 10px",
        fontSize: "22px"
      },
      lineHeight: "24px",
      color: "var(--factionAltColor, #fff)",
      backgroundColor: "var(--factionMainColor, white)"
    },
    topSpot: {
      backgroundColor: "var(--factionMainColor, #fff)",
      color: "var(--factionAltColor, #16191A)"
    },
    topNoFaction: {
      backgroundColor: "var(--factionAltColor, #16191A)",
      color: "var(--factionMainColor, #fff)"
    },
    crown: {
      position: "absolute",
      top: "-15px",
      left: "-13px"
    },
    bottom: {
      position: "absolute",
      display: "flex",
      gap: "5px",
      bottom: 8,
      right: 8
    },
    bottomImageWrapper: {
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      overflow: "visible",
      alignItems: "center",
      backgroundColor: "#171A1B",
      "& > img": {
        width: "24px",
        height: "24px"
      }
    },
    bottomImageWithCutoff: {
      overflow: "hidden"
    },
    content: {
      padding: "0px 15px",
      "@media (min-width: 1300px)": {
        padding: "0 30px"
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      "> h3 ": {
        fontSize: "16px",
        "@media (min-width: 1300px)": {
          fontSize: "18px"
        },
        textTransform: "uppercase",
        color: "#fff",
        marginBottom: "5px",
        marginTop: "5px",
        lineHeight: "18px"
      }
    },
    stats: {
      color: "#B0B0B0",
      width: "100%",
      fontSize: "16px"
    },
    statsInner: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "0px",
      "@media (min-width: 1300px)": {
        marginBottom: "5px"
      }
    },
    focusStat: {
      color: "var(--factionMainColor)"
    }
  };
});
export { useStyles as default };